import React from 'react';

export default function Contacts() {
  return (
    <div style={{ width: '100%', height: 'calc(100vh - 60px)' }}>
      <iframe
        src="/api/contacts"
        title="Contacts"
        style={{ width: '100%', height: '100%', border: 'none' }}
      />
    </div>
  );
}
